(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddOnlineExam", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemType/onlineExam/learningItemAddOnlineExamView.html",
            controller: ["tenantExamMessagesResource", "$localStorage", "$scope", "$uibModal", "EXAMDETAIL_STATUS", "_", LearningItemAddOnlineExamCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddOnlineExamCtrl(tenantExamMessagesResource, $localStorage, $scope, $uibModal, EXAMDETAIL_STATUS, _) {
            var vm = this;
            vm.$onInit = function () {
                vm.form = vm.wizard.formData.specificInfo;
                vm.type = vm.wizard.formData.type.stateName;
                //Initialize the ng-models
                vm.defaultLocalization = $localStorage.tenantSettings.defaultLocalization.id;
                if (!vm.form.initialized) {
                    vm.form.proctorTypeId = 0;
                    vm.form.showExamDetailId = EXAMDETAIL_STATUS.Disabled;
                    vm.form.requiresPassword = false;
                    vm.form.timed = true;
                    vm.form.timeLimit = 30;
                    vm.form.numberOfAttempts = 5;
                    vm.form.unlimitedAttempts = false;
                    vm.form.activePassMessage = 0;
                    vm.form.activeFailMessage = 0;
                    vm.form.initialized = true;
                    vm.form.learnerCanRequestAttempts = true;
                }
            };
            tenantExamMessagesResource.get(function (model) {
                vm.failMessages = _.filter(model.tenantExamMessages, function (item) { return item.type === "Fail"; });
                vm.passMessages = _.filter(model.tenantExamMessages, function (item) { return item.type === "Pass"; });
            });
            vm.setFailedMessageId = function (nextSlide) {
                vm.form.failMessageId = vm.failMessages[nextSlide.slide.index].id;
            };
            vm.setPassedMessageId = function (nextSlide) {
                vm.form.passMessageId = vm.passMessages[nextSlide.slide.index].id;
            };
            vm.openExamSelectionModal = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/learningItems/add/steps/learningItemType/onlineExam/examSelectionModalView.html",
                    controller: "ExamSelectionModalCtrl as vm",
                    scope: $scope,
                    size: "lg",
                    backdrop: "static"
                });
                modalInstance.result.then(function (selectedExam) {
                    vm.form.exam = selectedExam;
                    vm.form.examId = selectedExam.id;
                }).catch(angular.noop);
            };
        }
    });
}());
